module.exports = __webpack_public_path__ + "img/电梯动画11.fc48c38d.png";